<template>
  <div class="salesData">
    <SalesFilter
      @changeQuery="queryChange"
      :queryParams="queryParams"
      :exportLoading="exportLoading"
      @exportQuery="tableExport"
      mode="day"
    />
    <a-table
      class="tableContainer"
      :columns="SalesDataColumns"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="false"
      :data-source="TableData"
      rowKey="erpId"
      :scroll="{ x: '100%', y: 'calc(100vh - 330px)' }"
      :loading="tableLoading"
    >
      <template #action="action">
        <a-button type="link" @click="viewDetail(action.record)">查看提成明细</a-button>
      </template>
    </a-table>
    <a-row type="flex" justify="start" style="margin: 20px 0 0 20px">
      <a-col>
        <a-pagination
          v-if="Total"
          show-size-changer
          show-quick-jumper
          v-model:current="current"
          v-model:pageSize="pageSize"
          :total="Total"
          @change="onChangePage"
          @showSizeChange="onChangePage"
          :show-total="Total => `共${Total}条`"
        />
      </a-col>
    </a-row>
    <IndexDetail ref="Index" :query="tableQuery" />
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, onMounted, computed } from 'vue'
import SalesFilter from './components/salesFilter.vue'
import useTableTools from '@/views/hooks/useTableTools'
import { SalesDataColumns } from './config'
import IndexDetail from './indexDetail.vue'
import { salesBonusList } from '@/api/DataCenter'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'

const { normalizeExport, Total, current, pageSize, TableData } = useTableTools()

const tableLoading = ref(false)
const tableQuery = reactive({})
const store = useStore()
const defaultQuery = {
  erpId: null,
  realName: null,
  statDateBegin: null,
  statDateEnd: null
}
const { queryParams, initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.SALES_COMMISSION_STATS,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultQuery,
  normalize: params => ({
    ...cloneDeep(defaultQuery),
    ...cloneDeep(params)
  })
})

const queryChange = params => {
  const { realName: manageName, ...res } = params
  current.value = 1
  pageSize.value = 10
  const nextQuery = updateCache({ ...res, manageName })
  Object.assign(tableQuery, nextQuery)
  listQuery()
}
// 改变当前页
const onChangePage = (page, size) => {
  current.value = page
  pageSize.value = size
  listQuery()
}
// 查询数据
const listQuery = () => {
  tableLoading.value = true
  const params = {
    ...tableQuery,
    pageNo: current.value,
    pageSize: pageSize.value,
    statType: 1 //时间类型（1-日 2-周 3-月）
  }
  salesBonusList(params)
    .then(res => {
      const { list = [], totalCount } = res
      TableData.value = list
      Total.value = totalCount
    })
    .catch(() => {
      TableData.value = []
      Total.value = 0
    })
    .finally(() => {
      tableLoading.value = false
    })
  tableLoading.value = false
}

// 查看详情
const Index = ref(null)
const viewDetail = ctxRecord => {
  nextTick(() => {
    Index.value.visible = true
    Index.value.initdetail(ctxRecord)
  })
}

// 导出数据
const exportLoading = ref(false)
const tableExport = async params => {
  const { realName: manageName, ...res } = params
  exportLoading.value = true
  await normalizeExport(
    '/health-doctor-assistant/doctor-assistant/bonus/excel',
    {
      ...res,
      manageName,
      statType: 1
    },
    '销售提成统计',
    'post'
  )
  exportLoading.value = false
}

onMounted(() => {
  const initQuery = initFromCache()
  Object.assign(tableQuery, initQuery)
  listQuery()
})
</script>
<style scoped lang="scss">
.salesData {
  height: 100%;
  .tableContainer {
    padding: 10px 20px 0;
  }
}
</style>
